module.exports = __webpack_public_path__ + "img/app_logo.49a22e66.svg";